var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardAmex = function SvgCardAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card-amex_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 148"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".card-amex_svg__cls-1,.card-amex_svg__cls-2,.card-amex_svg__cls-4{fill:#0185ff;stroke-width:0}.card-amex_svg__cls-2,.card-amex_svg__cls-4{fill:#016fd0;fill-rule:evenodd}.card-amex_svg__cls-4{fill:#fff}"))), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 148,
    rx: 16,
    ry: 16,
    style: {
      fill: "#016fd0",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-2",
    d: "M153 4h70v70h-70V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-4",
    d: "M178.4 62.9V37.8H223v7l-5.2 5.5 5.2 5.6V63h-8.2l-4.4-4.8-4.3 4.9h-27.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-2",
    d: "M181.3 60.2V40.6h16.6v4.5h-11.2v3.1h11v4.4h-11v3h11.2v4.6h-16.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-2",
    d: "m197.9 60.2 9.2-9.8-9.2-9.8h7.1l5.6 6.2 5.6-6.2h6.8v.2l-9 9.6 9 9.5v.3h-6.9l-5.7-6.3-5.7 6.3h-6.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-4",
    d: "M180.4 15.6h10.8l3.8 8.6v-8.6h13.3l2.3 6.4 2.3-6.4H223v25.1h-53.6l11.1-25.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-2",
    d: "m182.5 18.3-8.7 19.6h6l1.6-3.9h8.9l1.6 3.9h6.1l-8.6-19.6h-6.9Zm.7 11.3 2.6-6.2 2.6 6.2h-5.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-2",
    d: "M197.9 37.9V18.3h8.4l4.3 12.1 4.3-12.1h8.1v19.6h-5.2V24.5l-4.9 13.4h-4.7l-5-13.4v13.4h-5.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__cls-1",
    d: "M40 73.2h-3.8c-1 0-1.8.8-1.8 1.8v6.8c0 1 .8 1.8 1.8 1.8H40c1 0 1.8-.8 1.8-1.8V75c0-1-.8-1.8-1.8-1.8ZM40.1 62.9h-3.8c-1 0-1.8.8-1.8 1.8v5c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-5c0-1-.8-1.8-1.8-1.8ZM49.6 74.9h-3.8c-1 0-1.8.8-1.8 1.8v5c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-5c0-1-.8-1.8-1.8-1.8ZM49.4 62.9h-3.8c-1 0-1.8.8-1.8 1.8v7.2c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-7.2c0-1-.8-1.8-1.8-1.8ZM32.6 81.8V64.4c0-.9-.8-1.6-1.7-1.6h-6.2c-.5 0-1 .2-1.3.6L21.3 66c-.2.3-.4.6-.4 1v12.7c0 .3.1.7.3.9l1.6 2.2c.3.4.8.7 1.4.7h6.7c.9 0 1.7-.8 1.7-1.7Z"
  })));
};
export default SvgCardAmex;